module.exports = __webpack_public_path__ + "img/where the wind priestess is.5e28e6d6.png";